import BaseClickAwayListener from '@material-ui/core/ClickAwayListener'

const ClickAwayListener = BaseClickAwayListener

export default ClickAwayListener
